import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { HttpClient, HttpHeaders, HttpRequest, HttpEventType } from '@angular/common/http';
import { StateService } from '@uirouter/angular';
import { FrontEndService } from './front-end.service';
import { LogService } from './log.service';

@Injectable()
export class HttpService {

  // baseUrl = 'http://10.19.1.10:8080/signet/';
  data = [];
  error_data = [];

  // TODO: Production
  baseUrl = 'https://gapi.goldkeys.net/signet/';
  // baseUrl = 'http://178.79.160.14:8000/signet/';
  // Staging server url - http://139.162.219.48;

  constructor(
    // private http: Http,
    private http: HttpClient,
    private stateService: StateService,
    private frontEndService: FrontEndService,
    private logService: LogService
  ) {
  }

  /**
   * Create authorization header for all http requests
   * @returns {Headers}
   */
  static createCommonAuthorizationHeader() {
    const headers = new HttpHeaders({
      'Accept': 'application/json'
    });
    // headers.set('Accept', "text/csv");
    // let headers: any;
    // const current_user = JSON.parse(localStorage.getItem('currentUser'));
    // if (current_user != null) {
    //   const storedToken = current_user.token_type + ' ' + current_user.token;
    //   // headers.append('Authorization', storedToken);
    //   // headers.append('Access-Control-Allow-Origin', "*");
    //   headers.append('Accept', "text/csv");

    //   // headers = new HttpHeaders().set('Authorization', storedToken);
    // }

    return headers;
  }

  handle_common_errors(
    error,
    callBack
  ) {
    /**
     * This function will handle errors from any method.
     */
    // this.logService.printLog("Error - ", error);
    try {
      this.error_data = JSON.parse(error);
    } catch (exception) {
      this.error_data = error;
      this.logService.printLog("Server error - ", error);
    }
    // this.logService.printLog('this.error_data  ', this.error_data);
    if (error['status'] === 401) {

      if (!localStorage.getItem('redirect_url')) {
        localStorage.setItem('redirect_url', window.location.pathname.toString());
      }

      this.stateService.go('login');

    } else if (error['status'] === 403) {
      // this.frontEndService.showAlert('Error', 'User is not allowed.');
      this.stateService.go('forbidden');

      // this.frontEndService.showAlert('Error', 'User is not allowed.');
      // this.frontEndService.sweetAlert('Error', 'User is not allowed.', 'error');

    } else if (this.error_data.hasOwnProperty('response') && this.error_data['response'].toLowerCase() !== 'ok') {
      // this.frontEndService.showAlert('Error', this.error_data['message']);
      this.frontEndService.sweetAlert('Error', this.error_data['message'], 'error');
    } else {
      // this.frontEndService.showAlert('Error', 'Your internet connection or server is not working properly');
      this.frontEndService.sweetAlert('Error', 'Your internet connection or server is not working properly', 'error');
    }
    this.error_data['response'] = "error";
    callBack(this.error_data);
    this.error_data = [];
  }

  handle_common_success(
    response,
    callBack
  ) {
    // // this.logService.printLog("Reponse - ", response);
    // if(response.hasOwnProperty("response") && response["response"].toLowerCase() === "error") {
    //   // this.logService.printLog("Reponse Error");

    //   this.frontEndService.sweetAlert('Error', this.error_data['message'], 'error');
    // }
    callBack(response);
  }

  delete_data(
    path,
    callBack
  ) {
    const headers = HttpService.createCommonAuthorizationHeader();

    return this.http.delete(this.baseUrl + path, { headers })
      .subscribe(
        (response) => {
          this.logService.printLog('Delete response - ', response);
          this.handle_common_success(response, callBack);
        },
        (error) => {
          this.handle_common_errors(error, callBack);
        },
        () => (this.data),
      );
  }

  downloadFiles(method, path, callBack){
    // Create the Xhr request object
    const xhr = new XMLHttpRequest();
    const url = this.baseUrl + path;
    let errorShown = false;

    xhr.open(method, url, true);
    xhr.responseType = 'blob';

    // Save token of user.
    const current_user = JSON.parse(localStorage.getItem('currentUser'));
    if (current_user != null) {
      const storedToken = current_user.token_type + ' ' + current_user.token;
      xhr.setRequestHeader('Authorization', storedToken);
    }

    // Xhr callback when we get a result back
    // We are not using arrow function because we need the 'this' context
    xhr.onreadystatechange = () => {

      // We use setTimeout to trigger change detection in Zones
      // setTimeout( () => { self.pending = false; }, 0);

      // If we get an HTTP status OK (200), save the file using fileSaver
      if (xhr.readyState === 4 && xhr.status === 200) {

        this.handle_common_success(xhr.response, callBack);
        // var blob = new Blob([this.response], {type: 'application/pdf'});
        // fileSaver.saveAs(blob, 'Report.pdf');
      } else {
        // this.handle_common_errors(xhr.response, UserServiceThisKeyword, callBack);
        // Added check as there are multiple responses but error should be shown once
        if (!errorShown) {
          callBack({ 'status': false });
          this.frontEndService.addToast('Error', 'unable_download_file', 'error');
          errorShown = true;
        }
      }
    };

    // Start the Ajax request
    xhr.send();
  }

  fetchData(
    path,
    callBack,
    download_files = false
  ) {
    // If call is to download files
    if (download_files) {

      this.downloadFiles('GET', path, callBack);

    } else {
      const headers = HttpService.createCommonAuthorizationHeader();

      return this.http.get(this.baseUrl + path, { headers })
        .subscribe(response => {
            this.logService.printLog('Get response - ', response);
            this.handle_common_success(response, callBack);
          },
          (error) => {
            this.handle_common_errors(error, callBack);
          },
          () => (this.data),
        );
    }
  }

  postData(
    jsonData,
    path,
    callBack,
    jsonToForm = false
  ) {


    // conversation json to form data
    if (jsonToForm === true) {

      // headers.append('Content-Type', 'multipart/form-data; charset = utf-8',);

      // let xhr: XMLHttpRequest = new XMLHttpRequest();

      // xhr.open('POST', this.baseUrl + path, true);

      // xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      // xhr.setRequestHeader('Content-Type', 'multipart/form-data; charset = utf-8');

      // const current_user = JSON.parse(localStorage.getItem('currentUser'));
      // if (current_user != null) {
      //   const storedToken = current_user.token_type + ' ' + current_user.token;
      //   xhr.setRequestHeader('Authorization', storedToken);
      // }

      // xhr.onreadystatechange = () => {
      //   if (xhr.readyState === 4) {
      //     if (xhr.status === 200) {
      //       this.logService.printLog("Post form data response for url - " + path, xhr.response);
      //       this.handle_common_success(xhr.response, callBack);
      //     } else {
      //       this.handle_common_errors(xhr.response, callBack);
      //     }
      //   }
      // };

      const formData = new FormData();
      for (const k in jsonData) {

        if (jsonData.hasOwnProperty(k)) {

          if (k === 'attached_file') {

            for (let num = 0; num < jsonData[k].length; num++) {
              formData.append(k, jsonData[k][num], jsonData[k][num].name);
            }

          } else {

            formData.append(k, jsonData[k]);
          }
        }
      }

      // xhr.send(formData);
      jsonData = formData;

      return this.http.post(this.baseUrl + path, jsonData)
        .subscribe(
          (response) => {
            // this.logService.printLog('Post response - ', response);
            this.handle_common_success(response, callBack);
          },
          (error) => {
            this.handle_common_errors(error, callBack);
          },
          () => (this.data),
        );



    } else {

      const headers = HttpService.createCommonAuthorizationHeader();

      return this.http.post(this.baseUrl + path, jsonData, { headers })
        .subscribe(
          (response) => {
            this.logService.printLog('Post response - ', response);
            this.handle_common_success(response, callBack);
          },
          (error) => {
            this.handle_common_errors(error, callBack);
          },
          () => (this.data),
        );
    }
  }


  downloadData(
    jsonData,
    path,
    callBack,
    jsonToForm = false,
  ) {
    // conversation json to form data
    if (jsonToForm === true) {
      const formData = new FormData();
      for (const k in jsonData) {
        if (jsonData.hasOwnProperty(k)) {
          if (k === 'attached_file') {
            for (let num = 0; num < jsonData[k].length; num++) {
              formData.append(k, jsonData[k][num], jsonData[k][num].name);
            }
          } else {
            formData.append(k, jsonData[k]);
          }
        }
      }
      jsonData = formData;
    }

    // xhr.send(formData);
    const headers = HttpService.createCommonAuthorizationHeader();
    return this.http.post(this.baseUrl + path, jsonData, { headers, responseType: 'blob' })
      .subscribe(
        (response) => {
          // this.logService.printLog('Post response - ', response);
          this.handle_common_success(response, callBack);
        },
        (error) => {
          // this.handle_common_success(error, callBack);
          this.handle_common_errors(error, callBack);
        },
        () => (this.data),
      );
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/services/http.service.ts